// Material Light — exact colors from LVGL 7 lv_theme_material.c (IS_LIGHT=true)
import { lighten, darken, OPA_20, OPA_30 } from '../themeUtils.js';

const COLOR_SCR          = '#eaeff3';   // IS_LIGHT screen bg
const COLOR_SCR_TEXT     = '#3b3e42';
const COLOR_BG           = '#ffffff';   // IS_LIGHT widget bg = white
const COLOR_BG_PR        = '#eeeeee';   // pressed
const COLOR_BG_SEC       = '#d4d7d9';   // secondary bg (bar/slider track)
const COLOR_BG_SEC_TEXT  = '#31404f';
const COLOR_BG_BORDER    = '#d6dde3';
const COLOR_BG_BORDER_PR = '#cccccc';
const COLOR_BG_TEXT      = '#3b3e42';   // dark text on white widgets
const COLOR_BG_TEXT_DIS  = '#aaaaaa';
const COLOR_BTN_DIS      = '#cccccc';   // IS_LIGHT
const COLOR_BTN_BORDER_INA = '#888888';

export function buildContext(primary, secondary) {
    const accent    = primary;
    const accentVar = lighten(primary, OPA_30);

    const pretty = {
        bg_color:     COLOR_BG,        // white
        bg_opa:       255,
        border_color: COLOR_BG_BORDER, // #d6dde3
        border_width: 2,
        radius:       8,
        text_color:   COLOR_BG_TEXT,   // dark text
    };

    const btnStyle = {
        bg_color:     COLOR_BG,        // white button bg
        bg_opa:       255,
        border_color: primary,         // primary-colored border
        border_width: 2,
        text_color:   COLOR_BG_TEXT,   // dark text on white button
        states: {
            checked:          { bg_color: primary,                               text_color: '#ffffff' },
            pressed:          { bg_color: darken(COLOR_BG, OPA_20),             text_color: COLOR_BG_TEXT },
            pressedChecked:   { bg_color: darken(primary, OPA_20),              text_color: '#ffffff' },
            disabled:         { text_color: COLOR_BG_TEXT_DIS },
            disabledChecked:  { bg_color: COLOR_BTN_DIS,                        text_color: COLOR_BG_TEXT_DIS },
        },
    };

    return {
        primary,
        secondary,
        accent,
        accentVar,
        pretty,
        btnStyle,
        COLOR_SCR,
        COLOR_SCR_TEXT,
        COLOR_BG,
        COLOR_BG_PR,
        COLOR_BG_SEC,
        COLOR_BG_SEC_TEXT,
        COLOR_BG_BORDER,
        COLOR_BG_BORDER_PR,
        COLOR_BG_TEXT,
        COLOR_BG_TEXT_DIS,
        COLOR_BTN_DIS,
        COLOR_BTN_BORDER_INA,
        TEXT: COLOR_BG_TEXT,    // alias used by some object files
    };
}
